/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';
import { formatDateAndTime } from '@/utils/formatDate';

import {
  InputDateFilter,
  TableDropdownFilter,
  TruncatedTextWithTooltip,
} from '@/components';
import { TableData } from '@/components/Table/types';
import { AssignListInfo } from '../../types';

export const getTableColumns = (
  data: AssignListInfo[] | undefined
): ColumnProps[] => {
  return [
    {
      field: 'tipoCarga',
      header: 'Tipo carga',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'contenedor',
      header: 'Unidad',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      style: { fontWeight: 'bold' },
    },
    {
      field: 'nombreExportador',
      header: 'Exportador',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'embarcador',
      header: 'Embarcador',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },

    {
      field: 'booking',
      header: 'Booking',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'observaciones',
      header: 'Observaciones',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData: AssignListInfo) =>
        rowData?.observaciones && rowData?.observaciones.length > 30 ? (
          <TruncatedTextWithTooltip
            text={rowData.observaciones ?? ''}
            maxLength={30}
          />
        ) : (
          rowData.observaciones
        ),
    },
    {
      field: 'mercaderia',
      header: 'Mercadería',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData: AssignListInfo) =>
        rowData.mercaderia.length > 30 ? (
          <TruncatedTextWithTooltip text={rowData.mercaderia} maxLength={30} />
        ) : (
          rowData.mercaderia
        ),
    },
    {
      field: 'destinoFinal',
      header: 'Destino',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tipo',
      header: 'Ti',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tipo"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tamano',
      header: 'Ta',
      filter: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <TableDropdownFilter
          options={options}
          data={data as TableData}
          fieldName="tamano"
        />
      ),
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'temperatura',
      header: 'Temp',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) =>
        rowData.temperatura !== null ? `${rowData.temperatura} °C` : '',
    },
    {
      field: 'ventilacion',
      header: 'Vent',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'imos',
      header: 'Imos',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'uns',
      header: 'UN',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'fecha',
      header: 'Fecha de recepción',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} displayMenu />
      ),
      headerStyle: { minWidth: '12rem' },
      filterField: 'fecha',
      dataType: 'date',
      body: (rowData) =>
        rowData.fecha ? formatDateAndTime(rowData.fecha) : '-',
    },
    {
      field: 'precinto1',
      header: 'Precinto 1',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto2',
      header: 'Precinto 2',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto3',
      header: 'Precinto 3',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'precinto4',
      header: 'Precinto 4',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'mgw',
      header: 'MGW',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'tara',
      header: 'Tara',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'peso',
      header: 'Peso',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },

    {
      field: 'humedad',
      header: 'Humedad',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'o2',
      header: 'O2',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'cO2',
      header: 'CO2',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
  ];
};
